import React, { useState } from 'react';
import { Button, Typography } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { StepPage } from "../../components/StepPage";
import { fromCents } from "../../../components/ServiceCreation/ServiceCreation.utils";
import { useGlobalContext } from "../../../contexts";
import { Intent } from "../../../infra/access-control";
import { useStoreActions } from "../../../store/store-context";
import { utils } from "../../../utils";
import { Card } from "../components/Card";
import { InsightCard } from "../components/InsightCard";
import { useRejectDeliveryModal } from "../components/RejectDeliveryModal";
import { SDALayout } from "../components/SDALayout";
import styles from "./ApproveDelivery.module.scss";
import { handleRequest } from "../../../infra/utils";
export function ApproveDelivery(_ref) {
  var _billCommand$price;

  let {
    onNextBtnClick,
    onBackBtnClick,
    rejectDelivery,
    relationship,
    service,
    billCommand
  } = _ref;
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const [showError, setShowError] = useState(false);
  const openRejectModal = useRejectDeliveryModal({
    relationshipId: relationship.id,
    serviceId: service.id,
    billCommandId: billCommand.id,
    rejectDelivery
  });

  async function approve() {
    logBI(11703, {
      serviceId: service.id
    });
    globalContext.startLoader('ApproveDelivery');
    const [,, hasError] = await handleRequest(api.billCommand.clientApprovesDelivery(relationship.id, service.id, billCommand.id));
    globalContext.stopLoader('ApproveDelivery');

    if (hasError) {
      setShowError(true);
    } else {
      onNextBtnClick();
    }
  }

  return /*#__PURE__*/React.createElement(StepPage, {
    relationship: relationship,
    header: "Review files and approve delivery",
    showError: showError,
    errorMessage: "An error has occurred. Please try again",
    errorTestid: "sda-approve-error",
    onBackBtnClick: onBackBtnClick,
    primaryBtn: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      intent: Intent.RejectDelivery,
      skin: "primaryOutline",
      onClick: openRejectModal,
      "data-testid": "sda-reject-btn"
    }, "Reject delivery"), /*#__PURE__*/React.createElement(Button, {
      intent: Intent.ApproveDelivery,
      onClick: approve,
      "data-testid": "sda-approve-btn"
    }, "Approve"))
  }, /*#__PURE__*/React.createElement(SDALayout, null, /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement(Typography, null, "Files for approval:")
  }, /*#__PURE__*/React.createElement("ul", null, billCommand.deliverables.files.map(file => /*#__PURE__*/React.createElement("li", {
    key: file.fileId,
    className: styles.item
  }, /*#__PURE__*/React.createElement(Checkmark, null), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, file.filename))))), /*#__PURE__*/React.createElement(InsightCard, null, "Upon approval, you will be billed", ' ', utils.formatDollarAmount(utils.calculateFinalPrice('price' in service.cost && typeof service.cost.price === 'number' ? service.cost.price : fromCents((_billCommand$price = billCommand.price) !== null && _billCommand$price !== void 0 ? _billCommand$price : 0) || 0, service.cost.discount, billCommand.quantity)), ", according to the agreement's payment terms.")));
}